import React, { useId } from 'react';
import { SearchInputGroup } from '@mts/ui';

function DirectorySearchBar({
  searchQuery,
  onSearchSubmit,
  onSearchChange,
}) {
  const inputId = useId();

  return (
    <div>
      <label htmlFor={inputId} className="sr-only">Search businesses, services, and public tags</label>
      <div className="rounded-xl bg-white/26 p-1.5 shadow-[0_14px_30px_rgba(15,23,42,0.32)]">
        <SearchInputGroup
          id={inputId}
          aria-describedby={`${inputId}-help`}
          maxLength={200}
          value={searchQuery}
          onChange={(e) => onSearchChange?.(e.target.value)}
          onSubmit={onSearchSubmit}
          placeholder="Search businesses, services, and public tags"
          className="w-full"
          inputClassName="h-12 border-white/70 bg-white text-base-content pl-12 pr-4 text-sm placeholder:text-base-content/45 shadow-[0_6px_16px_rgba(15,23,42,0.2)] focus:border-white focus:ring-4 focus:ring-cyan-100/55"
        />
      </div>

      <p id={`${inputId}-help`} className="mt-2 text-xs text-primary-content/80">Search by business name, keyword, or public tag.</p>
    </div>
  );
}

export default DirectorySearchBar;
